/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var TextDirection = require('./TextDirection.js');
var Text = require('./Text.js');
var createTextComponent = require('./createTextComponent.js');

createTextComponent.createTextComponent('label', 'Label');
const Legend = createTextComponent.createTextComponent('legend', 'Legend');

exports.TextDirection = TextDirection.TextDirection;
exports.Text = Text.Text;
exports.Legend = Legend;
